export function bind (el, event, handler) {
  if (el.addEventListener) {
    el.addEventListener(event, handler)
  } else if (document.attachEvent) {
    el.attachEvent(`on${event}`, handler)
  }
}

export function unbind (el, event, handler) {
  if (el.removeEventListener) {
    el.removeEventListener(event, handler)
  } else if (document.detachEvent) {
    el.detachEvent(`on${event}`, handler)
  }
}
